module.exports = __webpack_public_path__ + "static/fonts/PingFangRegular.5bd6da0.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/css/PingFangRegular.ttf
// module id = x6zP
// module chunks = 1